module.exports = __webpack_public_path__ + "static/media/export-graphic.d27a1d8d.png";